export default __webpack_public_path__ + "static/media/camera.c176f0fb.svg";